import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  linksRole: [],
  status: "idle",
  error: null,
};

export const linksRoleByCountrySlice = createSlice({
  name: "linksRole",
  initialState,
  reducers: {
    linksRoleRequested: (state) => {
      state.status = "loading";
    },
    linksRoleRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    linksRoleRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.linksRole = action.payload;
    },
  },
});

export const {
  linksRoleRequested,
  linksRoleRequestFailed,
  linksRoleRequestSucceeded,
} = linksRoleByCountrySlice.actions;

export default linksRoleByCountrySlice.reducer;
